import React, { useEffect, useState } from "react";
import Logo from "../../../assets/img/logo.png";
import { theme } from "./theme";
import { ThemeProvider } from "@mui/system";
import SuccessIcon from "../../../assets/img/check_icone_alert.png";
import { useParams } from "react-router-dom";
import api from "../../../config/api";
import { Spinner } from "react-bootstrap";

function EmailValidation() {
  const { id } = useParams();
  const [load, setLoad] = useState(true);
  const [message, setMessage] = useState("");
  const [successful, setSuccessful] = useState(false);

  const handleValidation = async () => {
    await api
      .patch(`/valid-user-email/${id}`)
      .then((resp) => {
        setMessage("E-mail validado com sucesso!");
        setSuccessful(true);
        console.log(resp);
      })
      .catch((error) => {
        setMessage("Ops, algo deu errado. Tente novamente mais tarde.");
        setSuccessful(false);
        console.log(error);
      })
      .finally(() => {
        setLoad(false);
      });
  };

  useEffect(() => {
    handleValidation();
  }, [id]);

  return (
    <ThemeProvider theme={theme}>
      <div className="container-fluid mb-5 mb-lg-0  h-100">
        <div className="row h-100">
          <div className="bg-img-login col-lg-7 d-flex justify-content-start align-items-end ">
            <div className="row m-0">
              <h1 className="title mb-3 text-white fz-34 ff-univanova-300">
                Bem-vindo ao <br />
                <span className="ff-univanova-bold">RESERVEI</span>
              </h1>
              {/* <h2 className="subtitle mb-4 text-white fz-16 ff-univanova-300">
                Lorem ipsum dolor sit amet, consetetur
              </h2> */}
            </div>
          </div>
          <div className="col-lg-5 mt-5 my-lg-auto">
            <div className="px-3 mb-5 mb-lg-0">
              <div className="w-100 d-flex justify-content-center mb-4">
                {successful && <img src={SuccessIcon} width={80} height={80} alt="" />}
              </div>
              <div className="d-flex justify-content-center align-items-center mb-5">
                <img alt="" src={Logo} />
              </div>
              <div className="mb-4">
                <h2 className="d-flex justify-content-center ff-univanova-600 fz-24 text-center text-cl-cyan mb-4">
                  {load ? (
                    <Spinner animation="border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  ) : (
                    message
                  )}
                </h2>
                <h2 className="d-flex justify-content-center ff-univanova-600 fz-24 text-cl-cyan">Obrigado.</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
}

export default EmailValidation;
